import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISpecialGroup } from "src/models/Products/SpecialGroup.models";

interface SpecialGroupState {
  specialGroups: ISpecialGroup[];
  specialGroupToEdit: ISpecialGroup | null;
}

const initialState: SpecialGroupState = {
  specialGroups: [],
  specialGroupToEdit: null,
};

const specialGroupSlice = createSlice({
  name: "SpecialGroup",
  initialState,
  reducers: {
    setSpecialGroupList: (state, action: PayloadAction<ISpecialGroup[]>) => {
      state.specialGroups = action.payload;
    },
    concatListSpecialGroup: (
      state: SpecialGroupState,
      action: PayloadAction<ISpecialGroup[]>
    ) => {
      state.specialGroups = [...state.specialGroups.concat(action.payload)];
    },
    setSpecialGroupToEdit: (
      state,
      action: PayloadAction<ISpecialGroup | null>
    ) => {
      state.specialGroupToEdit = action.payload;
    },
    addSpecialGroup: (state, action: PayloadAction<ISpecialGroup>) => {
      state.specialGroups.push(action.payload);
    },
    updateSpecialGroup: (state, action: PayloadAction<ISpecialGroup>) => {
      let itemIndex = state.specialGroups.findIndex(
        item => item.specialGroupId === action.payload.specialGroupId
      );
      if (itemIndex !== -1) state.specialGroups[itemIndex] = action.payload;
    },
    deleteSpecialGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.specialGroups.filter(
        item => item.specialGroupId !== action.payload
      );
      state.specialGroups = newArray;
    },
  },
});

export const {
  setSpecialGroupList,
  concatListSpecialGroup,
  setSpecialGroupToEdit,
  addSpecialGroup,
  updateSpecialGroup,
  deleteSpecialGroup,
} = specialGroupSlice.actions;

export default specialGroupSlice.reducer;
